import React from 'react'; 
import { Discharge } from './EmployeeDischargeList'; // Importa el tipo Discharge
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';

export interface DischargeDetailPopupProps {
  discharge: Discharge;
  onClose: () => void;
}

const DischargeDetailPopup: React.FC<DischargeDetailPopupProps> = ({ discharge, onClose }) => {
  const sendEmail = () => {
    const templateParams = {
      to_name: discharge.name, // Nombre del empleado
      message: `Se ha registrado un descargo el ${new Date(discharge.date).toLocaleDateString('es-ES')}.`,
      description: discharge.descargo, // Descripción del descargo
      supervisor: discharge.jefe, // Jefe que realizó el descargo
      from_email: 'kmalvarez118@gmail.com', // Tu correo
    };

    emailjs.send('service_abxuanp', 'template_8kx1h09', templateParams, 'EfmTfATTW0dc1cBdz')
      .then((response: any) => {
        console.log('Correo enviado con éxito:', response.status, response.text);
        toast.success('Notificación enviada al empleado.');
      }, (error: any) => {
        console.error('Error al enviar el correo:', error);
        toast.error('Error al enviar la notificación.');
      });
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/2 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-red-500 hover:text-red-600 text-6xl" // Aumentar tamaño de texto
        >
          &times; {/* Icono de cierre */}
        </button>

        <h2 className="text-xl font-semibold mb-4">Detalle del Descargo</h2>

        <p><strong>ID:</strong> {discharge.id}</p>
        <p><strong>Fecha:</strong> {new Date(discharge.date).toLocaleDateString('es-ES')}</p>
        <p><strong>Nombre del Empleado:</strong> {discharge.name}</p>
        <p><strong>Descripción:</strong> {discharge.descargo}</p>
        <p><strong>Testigo 1:</strong> {discharge.testigo1}</p>
        <p><strong>Testigo 2:</strong> {discharge.testigo2}</p>
        <p><strong>Jefe:</strong> {discharge.jefe}</p>
        <p><strong>Estado:</strong> {discharge.estado}</p>

        <div className="flex gap-2 mt-4">
          <button 
            onClick={() => {
              window.print(); // Aquí puedes agregar la lógica para imprimir
            }}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
          >
            Imprimir
          </button>

          <button 
            onClick={sendEmail} // Llama a la función para enviar el correo
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Notificar al Empleado
          </button>
        </div>
      </div>
    </div>
  );
};

export default DischargeDetailPopup;
